import { useMemo } from 'react';

import { useI18n } from '../../i18n';
import { JsonLd, SITE_ORIGIN, usePageMeta } from '../../lib/seo';
import ServiceProviderPage from '../components/ServiceProviderPage';

export default function ServiceProvider() {
  const { t, language } = useI18n();

  usePageMeta({
    title: t.seo.serviceProvider.title,
    description: t.seo.serviceProvider.description,
  });

  const breadcrumbName =
    t.nav.items.find((i) => i.id === 'service-provider')?.title ??
    t.serviceProvider.hero.title;

  const breadcrumbLd = useMemo(
    () => ({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: t.nav.home,
          item: `${SITE_ORIGIN}/${language}`,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: breadcrumbName,
          item: `${SITE_ORIGIN}/${language}/service-provider`,
        },
      ],
    }),
    [t.nav.home, breadcrumbName, language],
  );

  return (
    <>
      <JsonLd data={breadcrumbLd} />
      <ServiceProviderPage />
    </>
  );
}
